import { Fragment } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { BsChevronDown } from 'react-icons/bs'
import { Popover, Transition } from '@headlessui/react'
import { getFilters, setFilters } from '@/store/slices/speakersSlice'
import { useDispatch, useSelector } from 'react-redux'
import Search from '../common/Search'
import Loader from '../common/Loader'
import CategoriesMobileView from '../common/CategoriesMobileView'
import { getColumns } from '@/utils/General.util'
import styles from '@/styles/components/navbar.module.scss'
import Link from 'next/link'
const CategoriesDropdown = ({
  categories = [],
  storyStyle = '',
  isLoading,
  isError,
  view = '',
}) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const filters = useSelector(getFilters)

  const onParentCategoryClick = (parentCategory) => {
    const resultIDs = []

    categories?.forEach((item) => {
      if (item?.category == parentCategory?.category) {
        item?.subCategories?.map((subCategory) => {
          return resultIDs.push(subCategory?.id)
        })
      }
    })

    dispatch(
      setFilters({
        ...filters,
        categories: resultIDs,
        searchQuery: '',
        types: null,
        profileCategory: null,
        relatedSpeakers: null,
        sortOrder: null,
      })
    )
    router.push(`/speakers/categories/${parentCategory?.categorySlug}`)
  }

  return (
    <>
      {view !== 'Mobile' ? (
        <div className="flex items-center">
          <Popover className="pr-7">
            {({ open }) => (
              <>
                <Popover.Button
                  className={
                    open ? 'flex items-center outline-none' : 'flex items-center focus:outline-1 '
                  }
                >
                  <span className="text-sm tracking-wider tagline-font">Categories</span>
                  <BsChevronDown
                    className={`${
                      open
                        ? 'rotate-180 transform h-3.5 w-4 text-white ml-2'
                        : 'h-3.5 w-4 text-white ml-2'
                    }`}
                  />
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-400"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-90 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-90 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <div
                    className={classNames(
                      styles.footerImg,
                      'pb-4 absolute z-[99] inset-x-1/2 opacity-95 bg-black w-[100vw] mx-[-50vw] mt-5 md:mt-6 pt-9 bg-no-repeat bg-bottom bg-contain overflow-auto'
                    )}
                  >
                    <Popover.Panel className="uta-container">
                      {({ close }) => (
                        <>
                          {
                            <>
                              {isLoading || (isError && getColumns(categories?.length) > 0) ? (
                                <Loader isNavBar={true} />
                              ) : (
                                // <div
                                //   className={`${storyStyle} md:flex md:flex-wrap md:text-left text-center order-first h-auto hidden md:text-xs 2xl:text-sm`}
                                // >
                                <div
                                  className={`${storyStyle} columns-1 sm:columns-3 lg:columns-4 gap-6`}
                                >
                                  {categories?.map((item, index) => (
                                    <div key={index} className="break-inside-avoid mb-6 md:px-2">
                                      <nav>
                                        <h2
                                          tabIndex="0"
                                          aria-label={item.category}
                                          className="cursor-pointer text-white text-sm font-semibold tracking-[1px] py-2 tagline-font"
                                          onClick={() => {
                                            onParentCategoryClick(item)
                                            close()
                                          }}
                                        >
                                          {item?.category}
                                        </h2>
                                        <ul className="list-none lg:mb-3">
                                          {item?.subCategories?.map((subCategory, subIndex) => (
                                            <li
                                              key={subIndex}
                                              aria-label={subCategory?.name}
                                              className="py-[3px] "
                                            >
                                              <a
                                                tabIndex="0"
                                                className="block p-0 m-0 leading-[1.20rem] text-[14px] cursor-pointer text-[#B4B4B4] tracking-[0.5px] font-normal regular-font hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
                                                onClick={() => {
                                                  dispatch(
                                                    setFilters({
                                                      ...filters,
                                                      categories: [subCategory?.id],
                                                      searchQuery: '',
                                                      types: null,
                                                      profileCategory: null,
                                                      relatedSpeakers: null,
                                                      sortOrder: null,
                                                    })
                                                  )
                                                  router.push(
                                                    `/speakers/topics/${subCategory?.slug}`
                                                  )
                                                  close()
                                                }}
                                                onKeyDown={(evt) => {
                                                  if (evt.key == 'Enter') {
                                                    dispatch(
                                                      setFilters({
                                                        ...filters,
                                                        categories: [subCategory?.id],
                                                        searchQuery: '',
                                                        types: null,
                                                        profileCategory: null,
                                                        relatedSpeakers: null,
                                                        sortOrder: null,
                                                      })
                                                    )
                                                    router.push(
                                                      `/speakers/topics/${subCategory?.slug}`
                                                    )
                                                    evt?.preventDefault()
                                                    close()
                                                  }
                                                }}
                                              >
                                                {subCategory.name}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </nav>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </>
                          }
                        </>
                      )}
                    </Popover.Panel>
                  </div>
                </Transition>
              </>
            )}
          </Popover>
          <Search storyStyle={`${storyStyle}`} />
          <Link href="/book-now" legacyBehavior>
            <span className="text-sm tracking-wider pl-7 tagline-font cursor-pointer">
              Book Now
            </span>
          </Link>
        </div>
      ) : (
        <CategoriesMobileView
          className="flex gap-1 mt-3 text-lg font-semibold cursor-pointer"
          categories={categories}
          isLoading={isLoading}
          isError={isError}
          onParentCategoryClick={onParentCategoryClick}
        />
      )}
    </>
  )
}
export default CategoriesDropdown